export default class {
  parent = null;

  html = '';

  constructor(parent) {
    this.parent = parent;
  }

  set(data) {
    this.html = data.fullDescription || '';
  }

  get show() {
    return !!this.html;
  }
}
